import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, model, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SanctumAuthService } from '@freesixtyfive/auth';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  Inspection,
  InspectionItem,
  InspectionItemMetadata,
} from 'apps/frontend/src/app/shared/models/inspection.model';
import { InspectionService } from 'apps/frontend/src/app/shared/services/inspection.service';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-inspection-item-table',
  imports: [
    CommonModule,
    TableModule,
    ProgressBarModule,
    TranslateModule,
    ButtonModule,
    FormsModule,
    MultiSelectModule,
    TagModule,
    DatePickerModule,
    DialogModule,
    ReactiveFormsModule,
    TooltipModule,
  ],
  templateUrl: './inspection-item-table.component.html',
  styleUrl: './inspection-item-table.component.scss',
})
export class InspectionItemTableComponent {
  #router = inject(Router);
  #auth = inject(SanctumAuthService);
  #inspectionService = inject(InspectionService);
  #translateService = inject(TranslateService);

  canCheckItems = this.#auth.permissions().includes('check:inspectionItems');

  inspection = input.required<Inspection>();
  selectedInspection = model<Inspection | null>(null);
  popupVisible = model<boolean>(false);
  itemChecked = output<void>();

  #sectionTypeMap: Record<string, string> = {
    element: 'inspectionItem.sectionTypeElement',
    platform: 'inspectionItem.sectionTypePlatform',
  };

  inspectionItems = computed(() => {
    const items = this.inspection()?.models;
    return (items ?? []).map((item) => ({
      ...item,
      section_type: item.section_type
        ? this.#translateService.instant(
            this.#sectionTypeMap[item.section_type] ?? item.section_type,
          )
        : item.section_type,
    }));
  });
  public inspectionItemColumns = InspectionItemMetadata.inspectionItemColumns;
  protected readonly round = Math.round;

  manageItems() {
    this.selectedInspection.set(this.inspection());
    this.popupVisible.set(true);
  }

  reportDefect(item: InspectionItem) {
    this.#router.navigate(['/defects/new'], {
      queryParams: {
        modelType: item.model_type,
        modelId: item.model_id,
        returnUrl: '/inspections',
      },
    });
  }

  markAsChecked(item: InspectionItem) {
    this.#inspectionService.checkItem(item.id).subscribe({
      next: () => {
        this.itemChecked.emit();
      },
    });
  }
}
